import { styled } from 'styled-components';
import { maxWidth, minWidth } from '../utils/media-queries';
import { Spaces } from '../utils/spaces';
import { HeaderHeights } from '../utils/header-heights';

const StyledContentContainer = styled.main`
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 0 ${Spaces.XS};

  @media ${maxWidth.S} {
    margin-top: ${HeaderHeights.MAIN}px;
  }

  @media ${minWidth.M} {
    padding: 0 ${Spaces.S};
  }

  @media ${minWidth.XL} {
    padding: 0;
  }
`;

export { StyledContentContainer as ContentContainer };
